import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from '@/utils/index';
import { useTranslation } from 'react-i18next';

type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
  showStateLabel?: boolean;
};

const Switch = ({
  ref,
  className,
  showStateLabel,
  ...props
}: SwitchProps & { ref?: React.RefObject<React.ComponentRef<typeof SwitchPrimitives.Root> | null> }) => {
  const { t } = useTranslation('components', {
    keyPrefix: 'switch',
  });

  return (
    <div className='inline-flex items-center gap-2'>
      {showStateLabel && (
        <span aria-hidden className='text-body-s-regular text-text-default-secondary'>
          {t(props.checked ? 'stateLabel.on' : 'stateLabel.off')}
        </span>
      )}
      <SwitchPrimitives.Root
        className={cn(
          'peer group inline-flex h-7 w-13 shrink-0 items-center gap-0.5 rounded-full border-transparent p-0.5 transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
          'data-[state=unchecked]:bg-fill-switch-off data-[state=unchecked]:hover:bg-fill-switch-off-hover',
          'data-[state=checked]:bg-fill-switch-on data-[state=checked]:hover:bg-fill-switch-on-hover',
          'focus-visible:ring-offset-fill-background-neutral focus-visible:ring-black',
          className,
        )}
        {...props}
        ref={ref}
      >
        <SwitchPrimitives.Thumb
          className={cn(
            'bg-fill-background-neutral pointer-events-none block size-6 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-0',
          )}
        />
      </SwitchPrimitives.Root>
    </div>
  );
};
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
